import React, { useEffect, useState } from "react";
import { getApiUrl } from "../utils/api";

const Productsizechart = ({ sizeChartId }) => {
  const [sizeChart, setSizeChart] = useState(null);

  const fetchSizeChart = async () => {
    if (!sizeChartId) return;
    try {
      const res = await fetch(getApiUrl("product-getcharts"), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: sizeChartId }),
      });
      const result = await res.json();
      if (result.success) setSizeChart(result.data);
    } catch (error) {
      console.log("Failed to fetch size chart");
    }
  };

  useEffect(() => {
    fetchSizeChart();
  }, [sizeChartId]);

  if (!sizeChart) return <p className="mt-3">Loading size chart...</p>;

  // Helper to check if a field exists in any size item
  const hasField = (field) =>
    sizeChart.sizes?.some((item) => item[field] && item[field] !== "");

  return (
    <div className="size-card mt-4 p-3 border rounded">
      <h5 className="chart-title">{sizeChart.chartName}</h5>
      <div className="table-responsive-custom">
        <table className="table shadow-table">
          <thead>
            <tr>
              <th>Size</th>
              {hasField("bust") && <th>Bust</th>}
              {hasField("waist") && <th>Waist</th>}
              {hasField("hip") && <th>Hip</th>}
              {hasField("topLength") && <th>Top Length</th>}
              {hasField("pantLength") && <th>Pant Length</th>}
              {hasField("thigh") && <th>Thigh</th>}
            </tr>
          </thead>
          <tbody>
            {sizeChart.sizes?.length > 0 ? (
              sizeChart.sizes.map((item, index) => (
                <tr key={index}>
                  <td>{item.size || "-"}</td>
                  {hasField("bust") && <td>{item.bust || "-"}</td>}
                  {hasField("waist") && <td>{item.waist || "-"}</td>}
                  {hasField("hip") && <td>{item.hip || "-"}</td>}
                  {hasField("topLength") && <td>{item.topLength || "-"}</td>}
                  {hasField("pantLength") && <td>{item.pantLength || "-"}</td>}
                  {hasField("thigh") && <td>{item.thigh || "-"}</td>}
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="7" className="text-center">
                  No size details found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Productsizechart;
